<template>
    <div style="position: relative;top:115px;">
        <div class="column pagestyle___3At3P" style="height: 100%;">
            <div class="row">
                <div style="width: 630px; margin-right: 9%;float: left"></div>
                <div class="ant-form ant-form-horizontal"
                    style="position: relative;top: 50px;width: 430px; background: rgb(255, 255, 255); border-radius: 20px; padding: 60px 40px; box-shadow: rgba(235, 235, 235, 0.54) 0px 6px 10px 1px;">
                    <div class="row" style="margin-bottom: 20px;">
                        <h2 style="font-size: 18px; color: rgb(21, 21, 21); margin: 0px; flex: 1 1 0%;">欢迎登录</h2>
                    </div>
                    <div class="ant-row ant-form-item">
                        <div class="ant-col ant-form-item-control-wrapper">
                            <div class="ant-form-item-control">
                                <span class="ant-form-item-children">
                                    <span class="ant-input-affix-wrapper" style="height: 40px;">
                                        <span class="ant-input-prefix">
                                            <i class="layui-icon layui-icon-username"></i>
                                        </span>
                                        <input placeholder="请输入身份证号" type="text" id="idCard" class="ant-input"
                                            v-model="idCard">
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="ant-row ant-form-item" style="margin-bottom: 5px;">
                        <div class="ant-col ant-form-item-control-wrapper">
                            <div class="ant-form-item-control">
                                <span class="ant-form-item-children">
                                    <span class="ant-input-password ant-input-affix-wrapper" style="height: 40px;">
                                        <span class="ant-input-prefix">
                                            <i class="layui-icon layui-icon-password"></i>
                                        </span>
                                        <input type="password" placeholder="请输入登录密码" id="password" v-model="password"
                                            class="ant-input">
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="ant-row ant-form-item" style="margin-bottom: 5px;" @click="retrievePassword">
                        <div class="ant-col ant-form-item-control-wrapper">
                            <a class="wjmm" style="float:right;color: red;">
                                <i class="layui-icon layui-icon-help"></i>
                                忘记密码
                            </a>
                        </div>
                    </div> -->
                    <div class="ant-row ant-form-item">
                        <div class="ant-col ant-form-item-control-wrapper">
                            <div class="ant-form-item-control">
                                <div @click="immediatelyLogin" type="button" id="submit"
                                    class="ant-btn login-form-button ant-btn-primary" style="width: 100%; height: 40px;background: rgb(55, 151, 240);
                                border-radius: 0;line-height: 40px;font-size: 17px;">
                                    <span>立即登录</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="width: 50%; float: left;">
                        <a class="registerPersonal" @click="registerPersonal">注册账号</a>
                    </div>
                    <!-- <div style="width: 50%; float: right;">
                        <a style="float:right;" @click="retrievePassword">找回密码</a>
                    </div> -->
                </div>
            </div>
        </div>
        <el-dialog title="登录验证" :visible.sync="dialogVisible" width="24%">
            <slide-verify ref="slideblock" :l="42" :r="10" :w="310" :h="155" slider-text="向右滑动" @success="onSuccess"
                @fail="onFail" @refresh="onRefresh"></slide-verify>
        </el-dialog>
    </div>
</template>
<script>
    //import homePage from './components/homePage.vue';
    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                dialogVisible: false,
                idCard: '',
                password: ''
            }
        },
        created() {
            this.$storage.remove('token');
            this.$storage.remove('declareUser');

            console.log(this.$storage.get('declareUser'));
        },
        mounted() {
            this.$storage.remove('token');
            this.$storage.remove('declareUser');
        },
        methods: {
            retrievePassword(){

                this.$router.push({path:'/retrievePassword'});

            },
            onFail() {

            },
            onRefresh() {

                console.log('刷新！！！')

            },
            onSuccess() {

                const loading = this.$loading({
                    lock: true,
                    text: '登陆中，请稍后...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                let _this = this;
                let parames = new URLSearchParams();
                parames.append('idCard', this.idCard);
                parames.append('password', this.password);

                this.$axios.post(this.serverUrl + '/login', parames).then(resp => {
                    loading.close();
                    this.dialogVisible = false;

                    if (resp.data.code === 1) {

                        this.$message({
                            message: '登录成功',
                            offset: 100,
                            type: 'success',
                            duration: 1500
                        });

                        setTimeout(() => {
                            _this.$router.push('/train');
                            _this.$storage.set('token', resp.data.token);
                            _this.$storage.set('one_pa', resp.data.one_pa);
                            _this.$storage.set('declareUser', resp.data.data);
                        }, 1500);
                    } else {

                        //this.$refs.slideblock.reset();
                        this.$message({
                            message: resp.data.msg,
                            offset: 250,
                            type: 'warning',
                            duration: 1500
                        });
                    }
                }).catch(err => {
                    this.$message({
                        message: '服务器繁忙！',
                        type: 'warning'
                    });
                })

            },
            //跳转到个人注册
            registerPersonal() {
                this.$router.push('/personRegisternet');
            },
            immediatelyLogin() {
                if (this.idCard === '') {
                    this.$message({
                        message: '请填写身份证号！',
                        type: 'warning'
                    });
                    return false;
                } else if (this.password === '') {
                    this.$message({
                        message: '请填写密码！',
                        type: 'warning'
                    });
                    return false;
                }



                this.onSuccess();

                // this.dialogVisible = true;
            }

        }
    }
</script>

<style src="../../../static/css/login.css" scoped></style>

<style scoped>
    .el-dialog__body {
        padding: 15px 30px;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
    }

    .el-dialog {
        position: absolute;
        /* margin: 0 auto 50px; */
        right: 16%;
        top: 15%;
        border-radius: 2px;
        -webkit-box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
        box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 50%;
    }

    .pagestyle___3At3P {
        background-size: cover;
        width: 100%;
        min-height: 100%;
        position: relative;
        padding-bottom: 180px
    }
</style>


// WEBPACK FOOTER //
// src/components/internetplus/login.vue